import React from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Paper,
} from "@mui/material";
import { hra, nra } from "../../assets";

const ProfessionalAssociations = () => {
  return (
    <Box sx={{ backgroundColor: "#f2f2f2", py: 5, px: { xs: "auto", md: '50px' } }}>
      <Container >

        {/* SECTION TITLE */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 4,
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Playfair Display', serif !important",
              fontSize: { xs: "20px", md: "38px" },
              fontWeight: "600 !important",
              color: "#0f2e4d !important",
              whiteSpace: "nowrap",
            }}
          >
            Professional Associations
          </Typography>

          <Box
            sx={{
              flex: 1,
              height: "1px",
              background:
                "linear-gradient(to right, #0f63a5, transparent)",
            }}
          />
        </Box>

        {/* ASSOCIATION CARDS */}
        <Grid container columnSpacing={4} rowSpacing={3}>
          {associations.map((item, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Paper
                elevation={0}
                sx={{
                  backgroundColor: "#f7f7f7",
                  borderRadius: "12px",
                  p: 3,
                  borderLeft: "6px solid #0f63a5",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                {/* BLUE ICON BOX */}
                <Box
                  sx={{
                    width: 140,
                    height: 80,
                    // backgroundColor: "#0f63a5",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <Typography
                    sx={{
                      fontFamily: "'Lato', sans-serif !important",
                      fontWeight: "700 !important",
                      color: "#ffffff !important",
                      fontSize: "18px !important",
                    }}
                  >
                    {item.short}
                  </Typography> */}
                  <Box
                    component="img"
                    src={item.short}
                    sx={{
                      maxWidth: "75%",
                      maxHeight: "75%",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                {/* TEXT CONTENT */}
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "'Playfair Display', serif !important",
                      fontWeight: "600 !important",
                      fontSize: "16px !important",
                      color: "#0f2e4d !important",
                    }}
                  >
                    {item.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "'Lato', sans-serif !important",
                      fontSize: "14px !important",
                      color: "#555 !important",
                      mt: 0.5,
                      textAlign:'start'
                    }}
                  >
                    {item.role}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ProfessionalAssociations;


/* -------- DATA -------- */

const associations = [
  {
    short: hra,
    name: "Hyderabad Realtors Association",
    role: "Active Member",
  },
  {
    short: nra,
    name: "National Association of Realtors",
    role: "India Member",
  },
];